/** @format */

import {PointName} from 'components/charts/multiline-chart/model/common';

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {LogButton} from '../components/logs/log-button';
import {ScatterButtonData} from '../models/scatters';

const getScatterPointDataLogs = (
  name: PointName,
  buttonData?: ScatterButtonData,
): CommonChartData => {
  const primary = buttonData?.value ?? 0;

  return {
    name,
    primary,
    hide: !Boolean(primary),
    ...(buttonData
      ? {
          scatterOptions: {
            IconComponent: <LogButton buttonData={buttonData} />,
          },
        }
      : {}),
  };
};

export {getScatterPointDataLogs};
